import CancelablePromise from "mn-utils/CancelablePromise";
import {post, get} from "../../http";
import {uploadDocument} from "../../upload";
import {API_URL_HTTP} from "../../../config/api";

const URL_PREFIX = '/f2c/v1/admin/onboarding';

const formUrl = (...endpoints) => [URL_PREFIX, ...endpoints].join('/');
const formUrlCompany = (...endpoints) => formUrl('company-account', ...endpoints);
const formUrlProfile = (...endpoints) => formUrl('profile-account', ...endpoints);
const formUrlOwner = (...endpoints) => formUrl('company-owner', ...endpoints);
const formUrlOnboarding = (...endpoints) => formUrl('onboarding', ...endpoints);

export function apiV2KycDocumentUpload(params) {
  return uploadDocument({
    ...params,
    uploadUrl: params.uploadUrl || '/f2c/v1/admin/kyc-doc/upload',
  });
}

export function apiV2KycDocumentGet(params) {
  const url = `/f2c/v1/console/file/${params.id}`;

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return fetch(API_URL_HTTP + url);
}


export function apiAdminMerchantAccountCreate(params) {
  const url = formUrl('create-merchant-account');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

// company block

export function apiAdminMerchantCompanyGet(params) {
  const url = formUrlCompany('get');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

export function apiAdminMerchantCompanyCreate(params) {
  const url = formUrlCompany('create');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

export function apiAdminMerchantCompanyUpdate(params) {
  const url = formUrlCompany('update');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

// profile block

export function apiAdminMerchantProfileCreate(params) {
  const url = formUrlProfile('create');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

export function apiAdminMerchantProfileUpdate(params) {
  const url = formUrlProfile('update');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

export function apiAdminMerchantProfileDelete(params) {
  const url = formUrlProfile('delete');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

// owner block

export function apiAdminMerchantOwnerCreate(params) {
  const url = formUrlOwner('create');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

export function apiAdminMerchantOwnerUpdate(params) {
  const url = formUrlOwner('update');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

export function apiAdminMerchantOwnerDelete(params) {
  const url = formUrlOwner('delete');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}

// activate endpoint

export function apiAdminMerchantActivate(params) {
  const url = formUrl('activate-merchant');

  if (process.env.MOCK) {
    const response = {status: 'SUCCESS'};
    console.info({url, params, response});
    return CancelablePromise.delay(500, response);
  }

  return post(url, params);
}
